import env from '@/config/env';
import { CoreEnums } from '@/utils/domain/constants';
import { normalizeRoleToMember } from '@/utils/domain/constants/roles/roleNameHelpers';

/** Admin / Owner / SuperAdmin — full tenant administration (incl. `/configuration` menu). */
export const isTenantAdmin = (roles) => {
  const arr = Array.isArray(roles) ? roles : [roles];
  return arr.some((r) => env.USER_ADMIN_ROLES.includes(r ?? ''));
};

/** SuperAdmin only — lake file tree / download. */
export const isSuperAdmin = (roles) => {
  const arr = Array.isArray(roles) ? roles : [roles];
  return arr.some((r) => normalizeRoleToMember(r) === CoreEnums.RoleName.SuperAdmin);
};

/**
 * Staff roles that mirror admin inside module Launchpads (lists, apps,
 * agents, entities) but are blocked from the global `/configuration` menu
 * by route authority. `RoleCollaborator` belongs here.
 */
export const isStaffRole = (roles) => {
  const arr = Array.isArray(roles) ? roles : [roles];
  return isTenantAdmin(arr) || arr.includes(CoreEnums.RoleName.Collaborator);
};

/**
 * Per-item management flag from `/allowed` endpoints (AccessControl vs
 * Collaborator UX guide). Accepts either the normalised tile or its `raw`.
 */
export const itemCanManage = (item) => {
  if (!item) return false;
  if (item.canManage === true) return true;
  if (item.raw?.canManage === true) return true;
  return false;
};

/**
 * Folder/group management gate. When the API includes `canManage` on the
 * group row (runtime projection from `/report/groups`), honour it;
 * otherwise fall back to the legacy module-wide admin gate.
 */
export const groupCanManage = (group, legacyAdminGate = false) => {
  if (!group) return false;
  if (typeof group.canManage === 'boolean') {
    return group.canManage === true;
  }
  const raw = group.raw ?? group;
  if (typeof raw.canManage === 'boolean') {
    return raw.canManage === true;
  }
  return legacyAdminGate === true;
};
